export default "__VITE_ASSET__1heYUWPa__"